export const CANNED_RESPONSE_AUTOTAGS_RELEASE_DATE = '2023-07-18';
export const PRIVATE_SUGGESTED_CANNEDS_RELEASE_DATE = '2023-03-01';
